import DashboardIcon from "@mui/icons-material/Dashboard";
import SettingsIcon from "@mui/icons-material/Settings";

const settings = {
  id: "group-settings",
  title: "Settings",
  type: "group",
  children: [
    {
      id: "layouts",
      title: "My layouts",
      type: "item",
      url: "/layouts",
      icon: DashboardIcon,
    },
    {
      id: "preferences",
      title: "Preferences",
      type: "item",
      url: "/preferences",
      icon: SettingsIcon,
    },
  ],
};

export default settings;
